import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Stepper from '../../components/Stepper/Stepper'
import Navbar from '../../components/Navbar/Navbar'
import Products from '../../components/ProductLayout/Products.js'
import Footer from '../../components/Footer/Footer'
import Details from '../../components/Details/Details'
import Checkout from '../../components/Checkout/Checkout'
import useProductStore from '../../zustand/useProductStore'
import useOrderStore from '../../zustand/useOrderStore'
import usePropertyDetailsStore from '../../zustand/usePropertyDetailsStore'
import RegisterModal from '../../components/Login/RegistrationModal'
import ResetPasswordModal from '../../components/Login/ResetPasswordModal'

export const Home = () => {
  const resetProductDetails = useProductStore(state => state.resetProductDetails);
  const resetOrderDetails = useOrderStore(state => state.resetOrderDetails);
  const resetPropertyDetails = usePropertyDetailsStore(state => state.resetPropertyDetails);
  const [isResetOpen, setIsResetOpen] = useState(false)
  const [resetToken, setResetToken] = useState(null)

  let [activeStep, setActiveStep] = useState(0);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false)
  const [registerToken, setRegisterToken] = useState(null)
  const [companyData, setCompanyData] = useState(null)

  const [searchParams] = useSearchParams()

  const handleNextStep = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handlePreviousStep = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    resetProductDetails();
    resetOrderDetails();
    resetPropertyDetails();
  };

  useEffect(() => {
    const token = searchParams.get('token')
    const resetToken = searchParams.get('resetToken')
    if (token) {
      setRegisterToken(token)
      setIsRegisterOpen(true)

      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/invite-token?token=${token}`)
          .then(res => res.json())
          .then(data => {
            if (data.company) {
              setCompanyData(data.company)
            } else {
              setIsRegisterOpen(false)
            }
          })
          .catch(() => setIsRegisterOpen(false))
    }
    if (resetToken) {
      setIsResetOpen(true)
      setResetToken(resetToken)
    }
  }, [searchParams])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);



  return (
    <div>
      <Navbar />
      <Stepper activeStep={activeStep} setActiveStep={setActiveStep} handleNextStep={handleNextStep} />
      {
        activeStep === 0 && <Products handleNextStep={handleNextStep} />
      }
      {
        activeStep === 1 && <Details handleNextStep={handleNextStep} handlePreviousStep={handlePreviousStep} />
      }
      {
        activeStep === 2 && <Checkout setActiveStep={setActiveStep} handleReset={handleReset} handlePreviousStep={handlePreviousStep} />
      }
      <Footer />
        <RegisterModal
            isOpen={isRegisterOpen}
            onClose={() => setIsRegisterOpen(false)}
            token={registerToken}
            invitedCompanyData={companyData}
            mode="invite"
        />

      <ResetPasswordModal
          isOpen={isResetOpen}
          onClose={() => setIsResetOpen(false)}
          resetToken={resetToken}
      />
    </div>
  )
}
